module.exports = __webpack_public_path__ + "img/9791157842438.a1d169db.jpg";